import React from "react";
import ListingCover from "app/pages/Listing/ListingCover/ListingCover";
import PropTypes from "prop-types";
import { resolutionPropType } from "app/utils/propTypes";
import "./ListingHero.scss";
import LogoBrandContainer from "app/pages/.shared/LogoBrand/LogoBrandContainer";
import ShopSwitcherContainer from "app/pages/Home/ShopSwitcher/ShopSwitcherContainer";
import ShopSwitcher from "app/pages/Home/ShopSwitcher/ShopSwitcher";
import ZigzagBanner from "app/pages/.shared/ZigZagBanner/ZigZagBanner";
import { FormattedMessage } from "react-intl";
import MarketingBanner from "app/pages/Header/MarketingBanner/MarketingBanner";

const ListingHero = ({ resolution, marketingBanner }) => {
	return (
		<React.Fragment>
			<MarketingBanner
				launchAt={marketingBanner.launchAt}
				endAt={marketingBanner.endAt}
				textColor={marketingBanner.textColor}
				backgroundColor={marketingBanner.backgroundColor}
				message={marketingBanner.message}
				pages={marketingBanner.pages}
				promoCode={marketingBanner.promoCode}
			/>
			<div className="listing-hero">
				<ListingCover
					imgSmallSrc="https://res.cloudinary.com/perfectstay/image/upload/v1579601730/brands/TZ/TZ_cover_mob_750x750.png"
					imgSmallThumbnail="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"
					imgLargeSrc="https://res.cloudinary.com/perfectstay/image/upload/v1579601730/brands/TZ/TZ_cover_desk_1920x630.png"
					imgLargeThumbnail="iVBORw0KGgoAAAANSUhEUgAAADIAAAAQCAMAAABjhdy+AAABGlBMVEWLa12IZliMb2GbmZFwc3GWh3ufpZ6kqaCUgHSJaFqcoZtvb26Xj4VobHF0cm+gnZJ7cGqUg3ebkoeLk5GPdWd6aWKgopl5gYOXlYyCi4uQcmOOfXOYn5mFZVh1enmSfXCBcmuRmJWQemyAb2ZmZT5zeX6Fg3+Edm+Hjo59dHB2ZlaEZ1tsakhtc3mWi4Bob3V4a2ecnpeQkoxsaWWRjYV+hoeUm5iShXqIenKIbWB8Zlp/amCkpZp4c3B/fHV5d3VydneVfGyLc2aRfGd7dlZzbWqOiYJoa2t+fnx0aGCWmJKHiodvcmmbiHpucF6FfHdsa1OGfF+LhHpvZ1x8g4GglYiMgmqNiX6OgXd3fX6RhXGIcGNycEx7fGcFKd73AAAB3klEQVQoz3XR2WKaUBCA4aMCVUFQK0rFnQQ1GoOIghKXmGhcKFJj3Zq8/2t0ziGmzUX+u7n4hgFQo9GfyiYntaMMw6RDSTocprlQmvkGpQUyJoV7GO6F3z+LqX6jgTCpJFpSKAomSkjiS/KQRY08yl9ImxCODheBtBnmCxLIo0jkg0SjbZ+0/DMvdyaF9GeCgqkizUmrXg5acSYhq1zussF/NfBCEpNIHiE0rYQxKfd6vbJumLJ8nOt6GY8rCY+mIeFtOfCYBBA8BO7i9O+k2nwry/J2XauRUZ8fYZrDAkg3EhVCgnBXomUY6x+4tbqxLEtVu91/40aFDdD6cPyP0IeDuttlMpndYlStVkeLjB+ZNotdF6eqVir4QczDdjQq4Mb1Uqk+Llz7FWAqVUen0+n6dFpsrOmFVMLn8/7tzXEoiuLj0HBy68cP44qCV0ygcb3qExTMVorn/a+nJ9d1HWemiZrGU3ekGKuJNiYT6paihvXSH0QIfLKHPZDXV89z3eVSFLUZG7uLQc+dpWjbSn3IU+QAIBEg+Fc+PoJoQp738k4weO50loOBrcQJYfm4AuT97xNyBTW9m5uBLc5Y1hcvePQJi0mfkEAEZTFpXhFDCDyGZR0QmAzsOP+J/AWzFGqC4Y6Z5QAAAABJRU5ErkJggg=="
					resolution={resolution}
				/>
				<div className="listing-hero__marketing">
					<div className="listing-hero__headline">
						<FormattedMessage id="listing.cover.headline.label" />
					</div>
					<ZigzagBanner
						height={15}
						width={"200px"}
						backgroundColor="#f1b835"
						label={<FormattedMessage id="listing.cover.headline.ribbon.label" />}
						textColor="white"
					/>
				</div>
				<header className="listing-hero__header">
					<div className="listing-hero__left" />
					<div className="listing-hero__brand">
						<LogoBrandContainer isWhite={true} />
					</div>
					<div className="listing-hero__shop">
						<ShopSwitcherContainer
							renderComponent={props => (
								<ShopSwitcher {...props} pathname="listing" />
							)}
						/>
					</div>
				</header>
			</div>
		</React.Fragment>
	);
};

ListingHero.propTypes = {
	resolution: resolutionPropType,
	marketingBanner: PropTypes.object,
};

ListingHero.defaultProps = {
	marketingBanner: {},
};

export default React.memo(ListingHero);
